import React from 'react';
import { Home, Features, Solutions, Contact, Partner, Download, FAQ, Freetrial } from './pages/page';
import { Route } from 'react-router-dom';

const Items = [
    {
        path: '/',
        component: Home,
        name: 'Home'
    },
    {
        path: '/features',
        component: Features,
        name: 'Features'
    },
    {
        path: '/solutions',
        component: Solutions,
        name: 'Solutions'
    },
    {
        path: '/contact',
        component: Contact,
        name: 'Contact'
    },
    {
        path: '/partner',
        component: Partner,
        name: 'Partner'
    },
    {
        path: '/download',
        component: Download,
        name: 'Download'
    },
    {
        path: '/faq',
        component: FAQ,
        name: 'FAQ'
    },
    {
        path: '/free-trial',
        component: Freetrial,
        name: 'Freetrial'
    }
]

function RootRouter() {
    return (
        <>{ Items.map((item, index) => <Route exact path={item.path} component={item.component} key={index}/> )}</>
    )
}

export { RootRouter, Items }